export default "__VITE_ASSET__9cc1e36b__"